import React from "react";
import CustomTable from "../../../../../../components/table/table";

import "../style.css";

export default function View(props) {
  const handleEdit = () => { };

  console.log(props.basicData);
  return (
    <div>
      <div className="view-container">
        <h6>
          <b>Basic Details</b>
        </h6>

        <hr />

        <div className="data">
          <div className="row">
            <div className="col-3">Institution Name</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.institution_name ?? ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Proposal Title</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.project_title ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Project Guide 1</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.project_guide1 ?? ""}</div>
            <div className="col-3">Phone</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.project_guide1_phone ?? ""}
            </div>
            <div className="col-3">Email</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.project_guide1_email ?? ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Project Guide 2</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.project_guide2 ?? ""}</div>
            <div className="col-3">Phone</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.project_guide2_phone ?? ""}
            </div>
            <div className="col-3">Email</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.project_guide2_email ?? ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Name of the Leader</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.leader_student_name ?? ""}
            </div>
            <div className="col-3">Semester</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.leader_semester ?? ""}</div>
            <div className="col-3">Branch</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.leader_branch ?? ""}</div>
            <div className="col-3">Duration/Period of study</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.leader_duration ?? ""}</div>
            <div className="col-3">Email of the leader</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.leader_email ?? ""}</div>
            <div className="col-3">Phone Number of the leader</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.phone_number ?? ""}</div>
          </div>
          {Array.isArray(props.basicData.students) &&
            props.basicData.students.some(
              (s) => s.student_name && s.student_name.trim() !== ""
            ) && (
              <div className="row">
                <div className="col-12">Student Details</div>
                <div className="col-12">
                  <CustomTable
                    {...props}
                    columns={[
                      { title: "Student Name", field: "student_name" },
                      { title: "Semester", field: "semester" },
                      { title: "Branch", field: "branch" },
                      // { title: "Previous Year Mark", field: "mark" },
                      { title: "Duration", field: "duration" },
                    ]}
                    data={props.basicData?.students}
                  />
                </div>
              </div>
            )}
          {/* <div className="row">
            <div className="col-3">Previousyear Marklist</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData?.leader_marklist?.name ?? ""}
            </div>
          </div> */}
          <div className="row">
            <div className="col-3">Biodata</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData?.leader_resume?.name ?? ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Letter</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData?.letter?.name ?? ""}
            </div>
          </div>

          <div className="row">
            <div className="col-3">Proposal</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData?.file_upload_proposal?.name ?? ""}
            </div>
          </div>

          <div className="row">
            <div className="col-3">Short Details of Proposal</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.short_proposal_details ?? ""}
            </div>
          </div>
        </div>

        <hr />

        <div className="footer-buttons mt-3">
          <div
            className="secondary-btn"
            onClick={(e) => {
              props.action(1);
            }}
          >
            GO BACK
          </div>
          <div
            className="primary-btn"
            onClick={(e) => {
              props.action(2);
            }}
          >
            REGISTER
          </div>
        </div>
      </div>
    </div>
  );
}
